<template>
  <modal-base
    ref="modal"
    title="Link Communication"
    @close="cancel"
    is-double-column
  >
    <section-box>
      <template v-if="communicationLog.record_id">
        <h3 class="attach_comm--heading">Current Lead</h3>
        <p class="flex flex-vertical-center">
          {{ communicationLog.record_address }}
          <button-link class="ml-100" @click="detachRecord">Detach</button-link>
        </p>
        <hr>
      </template>

      <h3 class="attach_comm--heading">New Lead</h3>

      <form-field-input
        label="Search for Lead"
        v-model="searchForm.search_term"
        :debounce="searchForRecord"
      ></form-field-input>

      <form-field-radio
        v-show="recordResults.length"
        label="Leads"
        v-model="form.record_id"
        :items="recordResults"
        :option-label="(preview) => preview.address"
        :option-value="(preview) => preview.record_id"
      ></form-field-radio>

      <p v-if="!searchForm.search_term && !recordResults.length" class="search_container--empty">Enter a search term...</p>
      <p v-if="searchForm.search_term && !recordResults.length" class="search_container--empty">No leads found...</p>
    </section-box>

    <template v-slot:footer>
      <button-default
        @click="save"
      >Attach New Lead
      </button-default>
    </template>
  </modal-base>
</template>

<script>
import {destroyModal} from "../../../services/modals";
import api from "../../../api";
import ModalBase from "../../../components/modal/ModalBase";
import FormFieldRadio from "../../../components/form/FormFieldRadio";

export default {
  name: "AttachCommunicationLogToLeadModal",
  components: {FormFieldRadio, ModalBase},
  props: {
    communicationLog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      recordResults: [],
      form: {
        record_id: null,
      },
      searchForm: {
        search_term: "",
      }
    };
  },
  mounted() {
    this.$refs.modal.open();
  },
  methods: {
    save() {
      return api.communicationLogs.attachToRecord(this.communicationLog.id, this.form, this.validationErrors)
        .then(this.confirmed);
    },
    detachRecord() {
      return api.communicationLogs.attachToRecord(this.communicationLog.id, {record_id: null}, this.validationErrors)
        .then(this.confirmed);
    },
    searchForRecord() {
      if(this.searchForm.search_term) {
        return api.records.search(this.searchForm).then(response => {
          this.recordResults = response.data;
        });
      }
    },
    confirmed() {
      this.$emit("confirmed", this.date);
      destroyModal(this.$refs.modal);
    },
    cancel() {
      this.$emit("canceled");
      destroyModal(this.$refs.modal);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.attach_comm--heading {
  margin-bottom: 10px;
  font-weight: bold;
}

.search_container {
  padding-top: 1rem;
  min-height: 280px;

  &--heading {
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 1.125rem;
  }

  &--empty {
    margin-top: 8px;
    padding: 10px;
    color: $text-muted;
    font-style: italic;
  }
}
</style>
